"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

/**
 * Renders a dots navigation component for the carousel, with clickable dots that transition to the corresponding slide.
 *
 * @extends React.Component
 */
class Dots extends _react.Component {
  static get propTypes() {
    return {
      numSlides: _propTypes.default.number.isRequired,
      selectedIndex: _propTypes.default.number.isRequired,
      goToSlide: _propTypes.default.func.isRequired
    };
  }

  render() {
    const {
      numSlides,
      selectedIndex,
      goToSlide
    } = this.props;
    const dots = [];

    for (let index = 0; index < numSlides; index++) {
      const buttonClass = (0, _classnames.default)('carousel-dot', {
        selected: index === selectedIndex
      });
      dots.push( /*#__PURE__*/_react.default.createElement("li", {
        key: `dot-${index}`
      }, /*#__PURE__*/_react.default.createElement("button", {
        className: buttonClass,
        onClick: goToSlide.bind(null, index)
      }, "\u2022")));
    }

    return /*#__PURE__*/_react.default.createElement("ul", {
      className: "carousel-dots"
    }, dots);
  }

}

exports.default = Dots;